import { useState } from 'react';
import NewsHero from './components/NewsHero';
import NewsList from './components/NewsList';

export default function NewsPage() {
  const [activeCategory, setActiveCategory] = useState('all');

  return (
    <main>
      <NewsHero
        activeCategory={activeCategory}
        onCategoryChange={setActiveCategory}
      />

      <section className="relative bg-brand-gray py-12 md:py-16">
        <div className="px-6 md:px-10">
          <div className="max-w-7xl mx-auto">
            <NewsList activeCategory={activeCategory} />
          </div>
        </div>
      </section>
    </main>
  );
}